// import components
import { ControlledTextField } from 'components/shared/ControlledFields';
import { styled } from '@mui/material';

export const StyledControlledReadOnlyTextField = styled(ControlledTextField)(
  ({ theme }) => ({
    '& .Mui-readOnly': {
      padding: 0,
      marginTop: theme.spacing(-1.5)
    },

    '& .MuiFormLabel-root': {
      position: 'relative',
      transform: 'none',
      paddingBottom: theme.spacing(3)
    },

    '& .MuiOutlinedInput-notchedOutline': {
      border: 0
    },

    '& .MuiFormHelperText-root': {
      marginLeft: 0
    }
  })
);
